export { default } from './TravelIcon';
